import { Anchor, Center, Stack, Text, Title } from "@mantine/core";
import { createFileRoute, redirect } from "@tanstack/react-router";

import { HeaderBase, HeaderUser } from "@/components/header";

export const Route = createFileRoute("/_app/(single-location)/museum/")({
  beforeLoad: ({ context }) => {
    if (context.locations && context.locations.length > 0) {
      redirect({
        to: "/museum/$museumId/bookings",
        params: { museumId: context.locations[0].id },
        throw: true,
      });
    }
  },
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <Stack>
      <HeaderBase>
        <HeaderUser />
      </HeaderBase>

      <Center mt="xl">
        <Stack>
          <Title order={3} ta="center">
            Ser ut til at du ikke har tilgang til noen av museene.
          </Title>
          <Text ta="center">
            Ta kontakt med oss på{" "}
            <Anchor href="mailto:post@museumnord.no">post@museumnord.no</Anchor>{" "}
            for å løse dette problemet
          </Text>
        </Stack>
      </Center>
    </Stack>
  );
}
